
import GizerdImage from './assets/imported_products/gizerd.jpg';
import NorwaySalmonImage from './assets/imported_products/norway-salmon.png';
import UgandaImage from './assets/imported_products/uganda.jpg';
import VietnamBasaImage from './assets/imported_products/vietnam_basa.png';
import HilsaImage from './assets/imported_products/hilsa.jpg';
import TunaImage from './assets/imported_products/tuna.jpg';

import PomfretImage from './assets/domestic_products/pomfret.png';
import ShrimpImage from './assets/domestic_products/shrimp.png';
import SquidImage from './assets/domestic_products/squid.png';
import VetkiImage from './assets/domestic_products/vetki.png';
import CrabImage from './assets/domestic_products/crab.png';
import LobstarImage from './assets/domestic_products/lobstar.png';
import OctopusImage from './assets/domestic_products/octopus.jpg';
import KhoyraImage from './assets/domestic_products/khoyra.jpg';
import TilapiaImage from './assets/domestic_products/tilapia.jpg';
import IndianBasaImage from './assets/domestic_products/indian_basa.jpg';

export const IMPORTED_PRODUCTS = [
    { image: VietnamBasaImage, name: 'Vietnam basa' },
    { image: NorwaySalmonImage, name: 'Norway salmon' },
    { image: GizerdImage, name: 'Gizerd from barma' },
    { image: UgandaImage, name: 'Nile perch from uganda' },
    { image: HilsaImage, name: 'Hilsha from bangladesh' },
    { image: TunaImage, name: 'Tuna' }
]

export const DOMESTIC_PRODUCTS = [
    { image: ShrimpImage, name: 'Shrimp' },
    { image: CrabImage, name: 'Crab' },
    { image: SquidImage, name: 'Squid' },
    { image: OctopusImage, name: 'Octopus' },
    { image: LobstarImage, name: 'Lobstar' },
    { image: PomfretImage, name: 'Pomfret' },
    { image: VetkiImage, name: 'Vetki' },
    { image: KhoyraImage, name: 'Khoyra' },
    { image: TilapiaImage, name: 'Tilapia' },
    { image: IndianBasaImage, name: 'Indian Basa' },
]